import React, { useState, useEffect } from "react";
import {
  FaPhone,
  FaSmile,
  FaRegCheckCircle,
  FaArrowUp,
  FaArrowDown,
} from "react-icons/fa";
import Tippy from "@tippyjs/react";
import Tools from '../utils/Tools';

function AgentViewTiles({ agent }) {
  const [tiles, setTiles] = useState([]);

  const getPeerComparisonElement = (agentValue, peerValue) => {
    const percentage = agentValue / peerValue;
    const isPositive = percentage > 1;
    const change = 1 - percentage;
    const Icon = isPositive ? FaArrowUp : FaArrowDown;
    const element = (
      <span className="text-sm flex items-center">
        <Icon className="mr-1" />
        {(Math.abs(change) * 100).toFixed(2)}% (peer average)
      </span>
    );
    return element;
  };

  useEffect(() => {
    console.log("agent record:", agent);
    // Update tiles based on allAgentInfo
    setTiles([
      { Icon: FaPhone, title: "Number of Calls", value: agent.totalCalls || 0 },
      {
        Icon: FaRegCheckCircle,
        title: "Average Professionalism",
        value: agent.averageProfessionalism.toFixed(3) || 0,
        trend: getPeerComparisonElement(
          agent.averageProfessionalism,
          agent.peerAverages.averageProfessionalism
        ),
        peerValue: agent.peerAverages.averageProfessionalism,
      },
      {
        Icon: FaSmile,
        title: "Average Sentiment",
        value: agent.averageSentiment.toFixed(3) || 0,
        trend: getPeerComparisonElement(
          agent.averageSentiment,
          agent.peerAverages.averageSentiment
        ),
        peerValue: agent.peerAverages.averageSentiment,
      },
      // Add more tiles as needed, using data from allAgentInfo
    ]);
  }, [agent]);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      {tiles.map((tile, index) => {
        //<Tippy content={"Peer value was " + tile.peerValue}>
        const tileContent = (
          <div
            key={index}
            className="bg-indigo-700 text-white p-4 rounded-xl shadow-lg flex items-center justify-between h-24 transition-all duration-300 hover:shadow-xl hover:scale-105"
          >
            <div className="flex flex-col items-center flex-grow">
              <div className="flex items-center">
                <p className="text-4xl font-bold">{tile.value}</p>
                {tile.trend && <span className="ml-2">{tile.trend}</span>}
              </div>
              <h3 className="text-sm font-semibold uppercase tracking-wide mt-1">
                {tile.title}
              </h3>
            </div>
            <tile.Icon className="text-4xl opacity-70 ml-4" />
          </div>
        );
        return tile.peerValue !== undefined ? (
          <Tippy
            key={index}
            content={`The average value for everyone else is ${tile.peerValue.toFixed(
              3
            )}.`}
          >
            {tileContent}
          </Tippy>
        ) : (
          tileContent
        );
        // </Tippy>
      })}
    </div>
  );
}

export default AgentViewTiles;
